import 'jquery-mask-plugin';
import Sortable from 'sortablejs';
import { Chart, registerables } from 'chart.js';
import 'owl.carousel';
import intlTelInput from 'intl-tel-input';
import {hideAll} from 'tippy.js';

Chart.register(...registerables);

export function initNotifyStyles() {
    $.notify.addStyle('activity', {
        html:
            "<div class='notify--message notify--activity'>" +
            "<div class='clearfix' style='display: flex; width: 100%;'>" +
                "<div class='activity-item--block d-flex'>" +
                    "<div class='activity-item--icon yellow'>" +
                        "<div class='icon icon--activity-check-black-white'></div>" +
                    "</div>" +
                        "<div class='activity-item--info'>" +
                            "<div data-if='title' data-notify-html='title' class='activity-item-info--title'></div>" +
                            "<div data-if='titleSecond' data-notify-html='titleSecond' class='activity-item-info--two-title'></div>" +
                        "</div>" +
                        "<div class='activity-item--status'>" +
                            "<div class='activity-item-status--indicator yellow'></div>" +
                            "<div class='activity-item-status--text'>Заказ сформирован</div>" +
                        "</div>" +
                    "</div>" +
                "</div>" +
            "</div>",
        conditions: {
            title: function (options) {
                console.log(options);
                return options.title !== undefined;
            },
            titleSecond: function (options) {
                console.log(options);
                return options.titleSecond !== undefined;
            },
        }
    });

    $.notify.addStyle('error', {
        html:
            "<div class='notify--message notify--error'>" +
            "<div class='clearfix' style='display: flex; width: 100%;'>" +
            "<div class='notify--icon'>" +
            "<span class='icon icon--notify-error'></span>" +
            "</div>" +
            "<div class='notify--text'>" +
            "<span class='notify--text-title' data-notify-html='title' />" +
            "<span class='notify--text-message' data-notify-html='message' />" +
            "</div>" +
            "<div class='notify--buttons'>" +
            "<span class='icon icon--notify-close'>" +
            "</div>" +
            "</div>" +
            "</div>"
    });

    $.notify.addStyle('success', {
        html:
            "<div class='notify--message notify--success'>" +
            "<div class='clearfix' style='display: flex; width: 100%;'>" +
            "<div class='notify--icon'>" +
            "<span class='icon icon--notify-success'></span>" +
            "</div>" +
            "<div class='notify--text'>" +
            "<span class='notify--text-title' data-notify-html='title' />" +
            "<span class='notify--text-message' data-notify-html='message' />" +
            "</div>" +
            "<div class='notify--buttons'>" +
            "<span class='icon icon--notify-close'>" +
            "</div>" +
            "</div>" +
            "</div>"
    });

    //listen for click events from this style
    $(document).on('click', '.notifyjs-error-base .notify--buttons .icon--notify-close, .notifyjs-notice-base .notify--buttons .icon--notify-close, .notifyjs-success-base .notify--buttons .icon--notify-close', function() {
        //programmatically trigger propogating hide event
        $(this).trigger('notify-hide');
    });
}

export const findParent = (el, className) => {
    let _this = el;

    while (_this && !_this.classList.contains(className)) {
        _this = _this.parentNode;

        if (_this === document.body) {
            _this = null;
        }
    }

    return _this;
}

export const _isMobile = (thisWidth) => {
    let _laptopXs = '769';

    if (thisWidth !== '') {
        _laptopXs = thisWidth;
    }

    let _width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    let _isMobileAttr = false;
    if (_width <= _laptopXs) {
        _isMobileAttr = true;
    }

    return _isMobileAttr;
}

export function formatNumber(number, n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = Number((number)).toFixed(Math.max(0, ~~n)).toLocaleString();

    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
}

window.uniqId = function(prefix) {
    return prefix + '-' + Math.round(new Date().getTime() + (Math.random() * 100));
}

window.changeTippyPositions = function(tippys) {
    let distance;
    let flag = true;

    tippys.each(function (index, value) {
        if (typeof $(this).find('.tippy-box').first().attr('data-escaped') !== 'undefined') {
            flag = false;
        }
    });

    if (!flag) {
        hideAll();
        return false;
    }

    if (tippys && $(tippys[0]) && $(tippys[0]).offset()) {
        distance = Math.sqrt(Math.pow($(tippys[0]).offset().left - $(tippys[1]).offset().left, 2) + Math.pow($(tippys[0]).offset().top - $(tippys[1]).offset().top, 2));

        if (distance < 100) {
            let firstTippy = $(tippys[0]);
            let secondTippy = $(tippys[1])

            if (distance >= 2) {
                firstTippy = $(tippys[1]);
                secondTippy = $(tippys[0])
            }

            let transform = getComputedStyle(secondTippy[0]).getPropertyValue("transform");
            let transformMatrix = new DOMMatrix(transform);
            let currentX = transformMatrix.m41;
            let currentY = transformMatrix.m42;


            if (distance >= 2) {
                currentY = currentY + (firstTippy.height() + 20);
            } else {
                currentY = currentY - (firstTippy.height() + 20);
            }

            firstTippy[0].style.transform = `translate(${currentX}px, ${currentY}px)`;
        }
    }

    return true;
}

window.addLinksEmotion = function(){
    let emojiDiv, emojiDivExist, message;

    $('a.chat--chat-message--emotion').on('click', function(e) {
        e.preventDefault();

        message = $(this).closest('.chat--chat-message--body-one').find('.chat--chat-message--body-one--title').first()
        if (message.length > 0) {
            emojiDivExist = message.find('.chat--chat-message--body-one--emoji').first();
            if (emojiDivExist.length > 0) {
                emojiDivExist.text($(this).html());
            } else {
                emojiDiv = document.createElement("div");
                emojiDiv.setAttribute("class", "chat--chat-message--body-one--emoji");
                emojiDiv.textContent = $(this).html();
                message.append(emojiDiv);
            }

            hideAll();
        }
    })
}

function initTableHeight() {
    let tableElement = $('.item-detail--table:first-child');

    if (tableElement.length < 1) {
        return false;
    }

    if (_isMobile()) {
        tableElement.css('min-height', 'auto')
        return true;
    }

    let clientBodyHeight = $('.navbar').outerHeight();
    let clientWrapHeight = $('#wrap').innerHeight();
    let headerHeight = $('.header--navbar').height();
    let elementHeight = 0

    if (clientWrapHeight < clientBodyHeight) {
        elementHeight = clientBodyHeight - clientWrapHeight - headerHeight;
        let paginateElement = $('.paginate');

        if (paginateElement.length > 0) {
            paginateElement.css('padding-bottom', '30px');
            $('#wrap').css('padding-bottom', '0px');

            elementHeight - paginateElement.outerHeight();
        }

        tableElement.css('min-height', (tableElement.height() + elementHeight + 15) + 'px')
    }

    return true;
}

function changeDivContent(el) {
    let dataName = $(el).attr('data-name');
    if (dataName.length > 0) {
        let textareaElement = $('textarea[name="' + dataName + '"]');
        if (textareaElement.length > 0) {
            textareaElement.val($(el).text());
        }
    }
}

function validEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function removeParentError(parentDiv) {
    var errorParent = $(parentDiv).closest('.base-form--select.error')
    if (errorParent.length > 0) {
        errorParent.removeClass('error')
    }

    errorParent = $(parentDiv).closest('.base-form--between.error')
    if (errorParent.length > 0) {
        errorParent.removeClass('error')
    }
}

function initChatSupportHeight() {
    let chatSupportWrap = $('.chat--partners-support-chat');
    if (chatSupportWrap.length > 0) {
        setChatSupportHeight(chatSupportWrap);
    }
}

function setChatSupportHeight(chatSupportWrap) {
    let bodyChat = chatSupportWrap.find('.chat--chat-message--body');

    if (!_isMobile()) {
        bodyChat.css('height', '100%');
        bodyChat.css('max-height', '480px');
        bodyChat.css('min-height', '480px');

        return false;
    }

    let heightHeader = chatSupportWrap.find('.chat--chat-message--header').outerHeight();
    let heightFooter = chatSupportWrap.find('.chat--chat-message--bottom').outerHeight();

    let calculateHeight = (heightHeader + heightFooter);

    bodyChat.css('height', 'calc(100vh - ' + calculateHeight + 'px)');
    bodyChat.css('max-height', 'calc(100vh - ' + calculateHeight + 'px)');
    bodyChat.css('min-height', 'calc(100vh - ' + calculateHeight + 'px)');
}

function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

function initOwlSlider() {
    let owlSlider = $('.slider-in-modal');

    if (_isMobile(790)) {
        if (typeof owlSlider.data('owl.carousel') != 'undefined') {
            owlSlider.data('owl.carousel').destroy();
        }

        owlSlider.removeClass('owl-carousel');

        return false;
    }

    owlSlider.addClass('owl-carousel');
    owlSlider.owlCarousel({
        items: 1,
        nav: true,
    });

    return false;
}

function recountLabelNums(bodyToInsert, targetClassText, bodyToLabel, bodyToLabelPre, bodyToOriginal) {
    let inserText = '';
    let targets = $(bodyToInsert).find('.' + targetClassText);
    let count = 1;

    if (targets.length > 0) {
        targets.each(function () {
            inserText = bodyToLabel + ' ' + "<span>" + bodyToLabelPre + count + "</span>";
            if (targets.length === 1) {
                if (typeof bodyToOriginal !== 'undefined' && bodyToOriginal !== '') {
                    inserText = bodyToOriginal;
                } else {
                    inserText = bodyToLabel;
                }
            }
            $(this).find('.label-wrap > div').eq(0).html(inserText)
            count++;
        });
    }
}

window.onload = function () {
    document.body.classList.add('loaded_hiding');
    window.setTimeout(function () {
        document.body.classList.add('loaded');
        document.body.classList.remove('loaded_hiding');
    }, 500);
}

function handlePlaceholderChange(selector) {
    let iti = window.intlTelInputGlobals.getInstance(selector);
    if (iti.selectedCountryData.dialCode === '7') {
        $(selector).unbind('keyup paste');
        $(selector).mask('999 999-99-99');
    } else {
        $(selector).unmask();
        $(selector).bind('keyup paste', function(){
            this.value = this.value.replace(/[^0-9]/g, '');
        });
    }
}

/*
function destroyAllTelInputs() {
    const inputFlags = document.querySelectorAll(".phone-flag");
    if (inputFlags.length > 0) {
        for (let i = 0; i < inputFlags.length; i++) {
            let iti = window.intlTelInputGlobals.getInstance(inputFlags[i]);
            if (iti) {
                iti.destroy();
            }
        }
    }
}
 */

function initAllTelInputs() {
    const inputFlags = document.querySelectorAll(".phones--chooses .phone-flag");
    if (inputFlags.length > 0) {
        for (let i = 0; i < inputFlags.length; i++) {
            let iti = window.intlTelInputGlobals.getInstance(inputFlags[i]);
            if (!iti) {
                initTelInput(inputFlags[i]);
            }
        }
    }
}

function initTelInput(inputFlag) {
    intlTelInput(inputFlag, {
        autoFormat: true,
        allowExtensions: false,
        initialCountry: 'kz',
        nationalMode: false,
        numberType: "MOBILE",

        autoHideDialCode: false,
        autoPlaceholder: "aggressive",
        //placeholderNumberType: "MOBILE",
        preferredCountries: ['kz', 'ru', 'uz', 'kg', 'tr'],
        separateDialCode: true,
        utilsScript: "/assets/javascripts/intl-tel-input/utils.js",
        customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
            if (selectedCountryData.dialCode === '7') {
                return selectedCountryPlaceholder.replace(/[0-9]/g, '_');
            } else {
                return selectedCountryPlaceholder;
            }
        },
    }).promise.then(function() {
        handlePlaceholderChange(inputFlag);
    });

    inputFlag.addEventListener('countrychange', function(){
        handlePlaceholderChange(inputFlag);
    }, false);
}

$(window).on('resize', function(){
    initTableHeight();
    initChatSupportHeight();
    initOwlSlider();
});

(function() {
    initAllTelInputs()
    initNotifyStyles();

    $('.multi-select').selectpicker();

    $(document).on("changed.bs.select", ".multi-select", function (t) {
        removeParentError($(this))
    });

    $(document).on("click", ".nice-select .option:not(.disabled)", function (t) {
        removeParentError($(this))
    });

    $(document).on("click", ".on-select-show .nice-select .option:not(.disabled)", function (t) {
        let value = $(this).attr('data-value');
        let body = $(this).closest('.on-select-show').attr('data-body');
        $(body).addClass('d-none');
        if ($('#' + value)) {
            $('#' + value).removeClass('d-none');
        }
    });

    $(document).on("click", ".poll-change-type .nice-select .option:not(.disabled)", function (t) {
        let value = $(this).attr('data-value')
        $('.polls-fields .polls-field').removeClass('active')
        $('.polls-fields .polls-field--' + value).addClass('active')
    });

    $(document).on("change", ".inputText", function (t) {
        removeParentError($(this))
    });

    $(document).on("change", ".on-check-show", function (event) {
        let showDiv = $(this).attr('data-show');
        let hideDiv = $(this).attr('data-hide');

        if (typeof(hideDiv) !== "undefined" && hideDiv !== null) {
            $(hideDiv).addClass('d-none');
        }

        if (typeof(showDiv) !== "undefined" && showDiv !== null) {
            if (event.currentTarget.checked) {
                $(showDiv).removeClass('d-none');
            } else {
                $(showDiv).addClass('d-none');
            }
        }

        return false;
    });

    initChatSupportHeight();

    const mapArea = document.querySelector("#y-maps");
    if (mapArea !== null) {
        ymaps.ready(function () {
            var myMap = new ymaps.Map("y-maps", {
                center: [55.76, 37.64],
                zoom: 10
            });
        });
    }

    if ($('.slider-in-modal').length > 0) {
        initOwlSlider();
    }

    if ($('.drag-table').length > 0) {
        new Sortable($('.drag-table'), {
            swapThreshold: 1,
            forceFallback: true,
            animation: 150,
            filter: '.not-drag',
            onMove: function(evt) {
                return evt.related.className.indexOf('not-drag') === -1; //and this
            },
        });

    }

    if ($('.drag-wrap').length > 0) {
        let sortable;

        const all = document.querySelectorAll(".drag-wrap");
        for (let i = 0; i < all.length; i++) {
            new Sortable(all[i], {
                swapThreshold: 1,
                forceFallback: true,
                animation: 150,
                filter: '.not-drag',
                onMove: function(evt) {
                    return evt.related.className.indexOf('not-drag') === -1; //and this
                },
                onEnd: function (/**Event*/evt) {
                    let items = all[i].querySelectorAll('.drag-item input')
                    if (items.length > 0) {
                        for (let ii = 0; ii < items.length; ii++) {
                            items[ii].setAttribute('name', items[ii].name.replace(/\[([^\]]+)\]/g, '[' + ii + ']'))
                        }
                    }
                },
            });
        }
    }

    $('.inputTextarea textarea').on("keyup paste", function() {
        var maxlength = $(this).attr("maxlength");
        var currentLength = $(this).val().length;

        if (typeof maxlength == 'undefined' || maxlength === false) {
            return true;
        }

        if (currentLength > maxlength) {
            return false;
        }

        var parentDiv = $(this).closest('.inputTextarea');
        if (parentDiv.length > 0) {
            var textareaDiv = parentDiv.find('.textarea-count span');
            if (textareaDiv.length > 0) {
                textareaDiv.eq(0).empty().text(currentLength);
            }
        }
    });

    let before;
    $('[contentEditable="true"]').on('focus', function() {
        before = $(this).html();
    }).on('blur keyup paste', function() {
        if (before != $(this).html()) { $(this).trigger('change'); }
    });

    $('[contentEditable="true"]').on('change', function() { changeDivContent(this); });

    $(document).on('click', ".add-upload-mini-block", function() {
        var targetToCopyBlock = $(this).attr('data-target');
        var bodyToInsert = $(this).attr('data-body');

        if (typeof targetToCopyBlock == 'undefined' || targetToCopyBlock === false) {
            return false;
        }

        if (typeof bodyToInsert == 'undefined' || bodyToInsert === false) {
            return false;
        }

        if ($(targetToCopyBlock).length <= 0 || $(bodyToInsert).length <= 0) {
            return false;
        }

        var thisNewId = 'upload-' + Math.random().toString(36).substring(2, 15);
        var thisTargetId = 'upload-' + Math.random().toString(36).substring(2, 15);
        var dataHtml = $(targetToCopyBlock).clone().attr('id', thisNewId);

        dataHtml.find('.base-form-upload-input--wrap').eq(0).addClass('upload-button--empty')
        dataHtml.find('img.upload-button').eq(0).attr('src', $(dataHtml).find('img.upload-button').eq(0).attr('data-empty')).attr('data-target', thisTargetId)
        dataHtml.find('input.upload-input').eq(0).attr('id', thisTargetId).attr('value', null)

        var dataToCopy = $("<div />").append(dataHtml).html();
        var lastElement = $(bodyToInsert).find('.target--one:last');

        $(dataToCopy).insertAfter(lastElement);

        $('#'+thisNewId).find('.base-input-wrp .inputText').attr('name', thisNewId)

        return false;
    })

    $(document).on('click', ".add-upload-block", function() {
        var targetToCopyBlock = $(this).attr('data-target');
        var bodyToInsert = $(this).attr('data-body');
        var bodyToLabel = $(this).attr('data-label');
        var countVar = $(this).attr('data-count');

        if (typeof targetToCopyBlock == 'undefined' || targetToCopyBlock === false) {
            return false;
        }

        if (typeof bodyToInsert == 'undefined' || bodyToInsert === false) {
            return false;
        }

        if ($(targetToCopyBlock).length <= 0) {
            return false;
        }

        if ($(bodyToInsert).length <= 0) {
            return false;
        }

        if (typeof bodyToLabel == 'undefined' || bodyToLabel === false) {
            return false;
        }

        if (typeof countVar == 'undefined' || countVar === false) {
            return false;
        }

        var thisNewId = 'upload-' + Math.random().toString(36).substring(2, 15);
        var thisTargetId = 'upload-' + Math.random().toString(36).substring(2, 15);
        var dataHtml = $(targetToCopyBlock).clone().attr('id', thisNewId);

        dataHtml.find('.base-form-upload-input--wrap').eq(0).addClass('upload-button--empty')
        dataHtml.find('img.upload-button').eq(0).attr('src', $(dataHtml).find('img.upload-button').eq(0).attr('data-empty')).attr('data-target', thisTargetId)
        dataHtml.find('input.upload-input').eq(0).attr('id', thisTargetId).attr('value', null)

        var minusLink = '<a class="delete-target-block" href="#" data-target="#' + thisNewId + '"><span class="icon icon--select-minus"></span></a>';

        var dataToCopy = $("<div />").append(dataHtml).html();
        var lastElement = $(bodyToInsert).find('.target--one:last-child');

        $(dataToCopy).insertAfter(lastElement);

        var finalCount = parseInt(countVar, 10) + 1;
        var labelText = bodyToLabel + finalCount;

        $(this).attr('data-count', finalCount)

        $('#'+thisNewId).find('.base-form--with-button').empty().append(minusLink)
        $('#'+thisNewId).find('.base-input-wrp .inputText').attr('name', thisNewId)
        $('#'+thisNewId).find('.label-wrap > div').html(labelText);

        return false;
    });

    $(document).on('click', ".add-volume-block", function() {
        var targetToCopyBlock = $(this).attr('data-target');
        var bodyToInsert = $(this).attr('data-body');
        var bodyToLabel = $(this).attr('data-label');
        var countVar = $(this).attr('data-count');
        var deleteLabel = $(this).attr('data-delete');
        var typeData = $(this).attr('data-type');

        if (typeof targetToCopyBlock == 'undefined' || targetToCopyBlock === false) {
            return false;
        }

        if (typeof bodyToInsert == 'undefined' || bodyToInsert === false) {
            return false;
        }

        if (typeof bodyToLabel == 'undefined' || bodyToLabel === false) {
            return false;
        }

        if (typeof countVar == 'undefined' || countVar === false) {
            return false;
        }

        if ($(targetToCopyBlock).length <= 0 || $(bodyToInsert).length <= 0) {
            return false;
        }

        var thisNewId = 'choose-' + Math.random().toString(36).substring(2, 15);
        var dataToCopy = $("<div />").append($(targetToCopyBlock).clone().attr('id', thisNewId)).html();

        var lastElement = $(bodyToInsert).find('.target--one:last');

        $(dataToCopy).insertAfter(lastElement);

        var finalCount = parseInt(countVar, 10) + 1;
        var labelText = bodyToLabel + finalCount;

        $(this).attr('data-count', finalCount)

        if (typeof deleteLabel != 'undefined' && deleteLabel !== false && deleteLabel != "") {
            var minusLink = '<a class="delete-target-block" href="#" data-target="#' + thisNewId + '"><span class="color-FF695F font-weight-bold">' + deleteLabel + '</span></a>';
            $('#' + thisNewId).find('.base-form--right-side > a').empty().append(minusLink)
        }

        var inputs = $('#'+thisNewId).find('.base-input-wrp .inputText');

        if (inputs.length === 1) {
            $('#' + thisNewId).find('.base-input-wrp .inputText').attr('name', thisNewId)
        } else {
            var ii = 1;
            inputs.each(function() {
                $(this).attr('name', thisNewId + '-' + ii)
                ii++
            });
        }

        if (typeData && typeData != "" && typeData == 'input') {
            $('#' + thisNewId).find('.base-form-input--main .base-form--input > label > div').html(labelText);
        } else {
            $('#' + thisNewId).find('.base-form--label > label').html(labelText);
        }

        return false;
    })

    $(document).on('click', ".add-target-block", function() {
        var targetToCopyBlock = $(this).attr('data-target');
        var bodyToInsert = $(this).attr('data-body');
        var bodyToLabel = $(this).attr('data-label');
        var bodyToOriginal = $(this).attr('data-original');
        var bodyToLabelPre = $(this).attr('data-label-pre');
        var countVar = parseInt($(this).attr('data-count'), 10);

        if (typeof targetToCopyBlock == 'undefined' || targetToCopyBlock === false) {
            return false;
        }

        if (typeof bodyToInsert == 'undefined' || bodyToInsert === false) {
            return false;
        }

        if (typeof bodyToLabelPre == 'undefined' || bodyToLabelPre === false) {
            bodyToLabelPre = '№';
        }

        if ($(targetToCopyBlock).length <= 0) {
            return false;
        }

        if ($(bodyToInsert).length <= 0) {
            return false;
        }

        var thisNewId = 'choose-' + Math.random().toString(36).substring(2, 15);
        var dataToCopy = $("<div />").append($(targetToCopyBlock).clone().attr('id', thisNewId)).html();

        var minusLink = '<a class="delete-target-block" ';
        if (typeof bodyToOriginal !== 'undefined' && bodyToOriginal !== '') {
            minusLink += ' data-original="' + bodyToOriginal + '"';
        }

        minusLink += ' href="#" data-add-target="' + targetToCopyBlock + '" data-body="' + bodyToInsert + '" data-target="#' + thisNewId + '"><span class="icon icon--select-minus"></span></a>';

        var lastElement = $(bodyToInsert).find('.target--one:last-child');

        $(dataToCopy).insertAfter(lastElement);

        if (typeof countVar !== 'undefined' && countVar !== false) {
            $(this).attr('data-count', countVar++);
        }

        if ($('#'+thisNewId).find('.base-form--with-button').length > 0) {
            $('#' + thisNewId).find('.base-form--with-button').empty().append(minusLink)
        }

        if ($('#'+thisNewId + ' .base-input-wrp--with-button .base-button').length > 0) {
            $('#'+thisNewId + ' .base-input-wrp--with-button .base-button').replaceWith(minusLink)
        }

        let inputId;
        $('#'+thisNewId).find('.base-input-wrp .inputText').each(function(){
            inputId = 'input-' + Math.random().toString(36).substring(2, 15);
            $(this).attr('name', inputId);
            $(this).attr('value', '');
            $(this).attr('disabled', false)
        });

        if ((typeof bodyToLabel !== 'undefined' && bodyToLabel !== false)) {
            recountLabelNums(bodyToInsert, $(targetToCopyBlock).attr('class'), bodyToLabel, bodyToLabelPre);
        }

        if (targetToCopyBlock === '#choose-phone') {
            const inputFlag = document.querySelector(".target--one:last-child .phone-flag");
            initTelInput(inputFlag);
        }

        return false;
    });

    $(document).on('click', ".check-all", function(e) {
        var targetBlock = $(this).attr('data-target');

        if (typeof targetBlock == 'undefined' || targetBlock === false) {
            return false;
        }

        if ($(targetBlock).length > 0) {
            $(targetBlock).find(':checkbox').each(function() {
                this.checked = true;
            });
        }

        return false;
    })

    $(document).on('click', ".switch-button .names .name--item", function() {
        var targetBlock = $(this).attr('data-target');

        if (typeof targetBlock == 'undefined' || targetBlock === false) {
            return false;
        }

        var parentWrapDiv = $(this).closest('.modal-content');

        $(parentWrapDiv).find('.modal-body.base-area--body > div').removeClass('show')
        $(parentWrapDiv).find('.modal-body.base-area--body > div[data-id="' + targetBlock + '"]').addClass('show')

        return true
    })

    $(document).on('click', ".delete-target-block", function() {
        var targetBlock = $(this).attr('data-target');
        var targetParentBody = $(this).attr('data-body');
        var targetAddBlock = $(this).attr('data-add-target');
        //var targetAddOriginal = $(this).attr('data-original');

        if (typeof targetBlock == 'undefined' || targetBlock === false) {
            return false;
        }

        if ($(targetBlock).length > 0) {
            $(targetBlock).fadeOut(300, function(){
                $(this).remove();

                if ((typeof targetParentBody !== 'undefined' && typeof targetAddBlock !== 'undefined') &&
                    (targetParentBody !== false && targetAddBlock !== false)) {
                    let targetAddButton = $(targetParentBody).find('[data-target="' + targetAddBlock + '"]').eq(0);
                    recountLabelNums(targetParentBody, $(targetAddBlock).attr('class'), $(targetAddButton).attr('data-label'), $(targetAddButton).attr('data-label-pre'), $(targetAddButton).attr('data-original'));
                }
            });
        }
        return false;
    });

    $(document).on('click', ".add-generate", function(e) {
        let value = $(this).attr('data-generate');
        if (value != '') {
            $(value).val(uuidv4());
        }
    })

    $(document).on('click', ".chat--chat-item--click", function(e) {
        if (!_isMobile()) {
            return false;
        }

        e.preventDefault();

        $('.modal').modal('hide');

        let profileChat = $('.chat--chat-messages--block .chat--chat-messages');
        let modalMessage = $('#openMessangerModal');

        let clonned = profileChat.clone();
        $(clonned).addClass('d-flex').addClass('align-items-start').addClass('flex-column').addClass('flex-wrap');

        modalMessage.find('.modal-body').empty().append(clonned);

        modalMessage.modal('show');
        $('.modal-backdrop').remove();

        let heightHeader = modalMessage.find('.chat--chat-message--header').outerHeight();
        let heightFooter = modalMessage.find('.chat--chat-message--bottom').outerHeight();

        let calculateHeight = (heightHeader + heightFooter) + 74;

        let bodyChat = modalMessage.find('.modal-body .chat--chat-message--body');

        bodyChat.css('height', 'calc(100vh - ' + calculateHeight + 'px)');
        bodyChat.css('max-height', 'calc(100vh - ' + calculateHeight + 'px)');
        bodyChat.css('min-height', 'calc(100vh - ' + calculateHeight + 'px)');

        bodyChat.scrollTop(bodyChat[0].scrollHeight);
    });

    $(".toggle-password").click(function() {
        $(this).toggleClass("icon-toggle--password-hidden");
        var spanPassword = $(this).parent().find('span.password-field').eq(0);
        spanPassword.toggleClass('password-hidden');
    });

    $(".base-area--toggle .base-area--header").click(function(e) {
        e = window.event || e;
        if(this === e.target) {
            $(this).parent().toggleClass('open');
        }
    });

    $('.item-detail-list--types-v2').on('scroll', function() {
        let filter = $(this).find('.form-filter--wrap.open');

        if (filter && filter.length > 0) {
            let offsetTop = filter.offset().top
            let offsetHeight = filter.outerHeight(true)
            let offsetLeft = filter.offset().left

            $(this).parent().find('.form-filter--form').css({
                "top": (offsetTop + offsetHeight - 10) + "px",
                "left": offsetLeft + "px"
            });
        }
    });

    $(".form-filter--wrap .form-filter--select").click(function() {
        let offsetTop = $(this).parent().offset().top
        let offsetHeight = $(this).parent().outerHeight(true)
        let offsetLeft = $(this).parent().offset().left

        $(this).parent().find('.form-filter--form').css({
            "top": (offsetTop + offsetHeight - 10) + "px",
            "left": offsetLeft + "px"
        });

        $(this).parent().toggleClass('open');
    });

    $(".base-area-body-wrap--item .base-area--toggle").click(function() {
        $(this).closest('.base-area-body-wrap--item').toggleClass('open');
        $(this).closest('.base-area-body-wrap--item').find('.base-area-toggle--body').toggle();
    });

    $(".user-profile-reviews-more--text").click(function() {
        let target = $(this).attr('data-target');
        if (target.length > 0) {
            $(this).closest('.review-user--info').find(target).toggleClass('open');
            $(this).parent().find('a').toggleClass('active');
        }

        return false;
    });

    $(".subscribe-item--wrap").click(function() {
        let selected = $('.subscribes-list').find('.subscribe-item--wrap');
        if (selected.length > 1) {
            let itemSelectedMonth = $(this).attr('data-month')
            let itemSelectedPrice = $(this).attr('data-price')

            selected.removeClass('subscribe-item--selected');

            $(this).addClass('subscribe-item--selected');

            let spanMonth = $('.subscribes--total .subscribe-total-selected--month span');
            if (spanMonth.length > 0) {
                spanMonth.html(itemSelectedMonth);
            }

            let spanPrice = $('.subscribes--total .subscribe-total-selected--price span');
            if (spanPrice.length > 0) {
                spanPrice.html(itemSelectedPrice);
            }
        }

        return false;
    });

    $(".toggle-password-input").click(function() {
        $(this).toggleClass("icon-toggle--password-hidden");
        var inputPassword = $(this).parent().find('input').eq(0);
        if (inputPassword.attr('type') === 'password') {
            inputPassword.attr('type', 'text');
        } else {
            inputPassword.attr('type', 'password');
        }
    });

    $('.dropdown-keep-open').on('hide.bs.dropdown', function (e) {
        if (!e.clickEvent) {
            return true;
        }

        var target = $(e.clickEvent.target);

        return !(target.hasClass('dropdown-keep-open') || target.parents('.dropdown-keep-open').length);
    });

    $('.input-countable--wrap .input-countable--button').click(function () {
        let typeVar = $(this).attr('data-type');
        let $input = $(this).parent().find('input');
        let count = 0;

        if (typeVar === 'minus') {
            count = parseInt($input.val()) - 1;
            count = count < 1 ? 1 : count;
            $input.val(count);
        } else {
            $input.val(parseInt($input.val()) + 1);
        }

        $input.change();
        return false;
    });

    $('.base-checkbox-curcle--selected').on('click', function() {
        let attrFor = $(this).attr('for')
        let checkbox = $(this).find('input[type="checkbox"]#' + attrFor).eq(0);
        $(checkbox).prop('checked', !checkbox.prop("checked"))
    })

    $('.toggle-nav').on('click', function(e) {
        e.preventDefault();
        $(this).parent().find('.navbar-subnav').toggle('slow');
    })

    $('.poll-view--open').on('click', function() {
        let dataTarget = $(this).attr('data-target');
        let dataOpened = $(this).attr('data-opened');
        let dataClosed = $(this).attr('data-closed');

        if ($(dataTarget).length > 0) {
            if (!$(this).hasClass('opened')) {
                $(this).empty().html(dataOpened)
                $(dataTarget).addClass('opened')
                $(this).addClass('opened')
            } else {
                $(this).empty().html(dataClosed)
                $(dataTarget).removeClass('opened')
            }
        }

        return false;
    })

    function fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
        } catch (err) {}

        document.body.removeChild(textArea);
    }

    function copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function() {
        }, function(err) {});
    }

    $(document).on('click', '[data-action="copy"]', function (e) {
        let target = $(this).attr('data-target');

        $(target).prop("disabled", false);
        let text = $(target).val();
        $(target).prop("disabled", true)

        if (text) {
            copyTextToClipboard(text);
        }

        return false;
    })


    $('.base-form--radious input[type="checkbox"]').on('change', function() {
        let wrap = $(this).closest('.base-form--radious');

        wrap.find('input[type="checkbox"]').each(function(i, obj) {
            $(this).prop('checked', false);
        });

        $(this).prop('checked', true);
    });

    $('.flytime-equipment-purchase--one input.input-countable--input').on('change', function() {
        let dataTarget = $(this).attr('data-target');
        let dataSum;
        let total;
        let parent = $(this).closest('.flytime-equipment-purchase--prices');
        let allInputs = parent.find('input.input-countable--input');
        let allInputsSum = 0;

        if (dataTarget.length > 0) {

            if (allInputs.length > 0) {
                allInputs.each(function (index) {
                    dataSum = $(this).attr('data-sum');
                    dataSum = dataSum.replace(/\D/g, "");
                    if (dataSum.length > 0) {
                        allInputsSum += parseInt($(this).val()) * parseInt(dataSum);
                    }
                });
            }

            total = $(this).closest('.flytime-equipment-purchase--one').find(dataTarget);
            if (total.length > 0) {
                total.eq(0).empty().html(allInputsSum);
            }
        }

        let totalSum = 0;
        $('.flytime-equipment-purchase-total--price span').each( function() {
            let sum = $( this ).text();
            sum = sum.replace(/\D/g, "");
            totalSum = totalSum + parseInt(sum);
        });

        $('.flytime-equipment-purchase-all-total--sum span').empty().html(totalSum);
    });

    if ($('.js-inline-picker').length > 0) {
        var pickerBday = new Picker(document.querySelector('.js-inline-picker'), {
            controls: false,
            inline: true,
            format: 'MMM/DD/YYYY',
            monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        });
    }

    initTableHeight();

    var optionsChartPie = {legend: {display: true}, title: {display: true}};

    var canvas = document.getElementById("pieChartSex");
    if (canvas) {
        var ctx = canvas.getContext('2d');
        var data = {
            labels: [],
            datasets: [
                {
                    fill: true,
                    backgroundColor: ['#2481A6', '#88F2F2'],
                    data: [5, 95],
                    borderWidth: [0, 0]
                }
            ]
        };

        var myBarChart = new Chart(ctx, {type: 'pie', data: data, options: optionsChartPie});
    }

    var canvasAge = document.getElementById("pieChartAge");
    if (canvasAge) {
        var ctxAge = canvasAge.getContext('2d');
        var dataAge = {
            labels: [],
            datasets: [
                {
                    fill: true,
                    backgroundColor: ['#2481A6', '#88F2F2', '#F2F2F2'],
                    data: [25, 65, 10],
                    borderWidth: [0, 0, 0]
                }
            ]
        };
        var myBarChartAge = new Chart(ctxAge, {type: 'pie', data: dataAge, options: optionsChartPie});
    }

    var canvasTwo = document.getElementById("pieChartSexTwo");
    if (canvasTwo) {
        var ctxTwo = canvasTwo.getContext('2d');
        var dataTwo = {
            labels: [],
            datasets: [
                {
                    fill: true,
                    backgroundColor: ['#2481A6', '#88F2F2'],
                    data: [5, 95],
                    borderWidth: [0, 0]
                }
            ]
        };

        var myBarChartTwo = new Chart(ctxTwo, {type: 'pie', data: dataTwo, options: optionsChartPie});
    }

    var canvasAgeTwo = document.getElementById("pieChartAgeTwo");
    if (canvasAgeTwo) {
        var ctxAgeTwo = canvasAgeTwo.getContext('2d');
        var dataAgeTwo = {
            labels: [],
            datasets: [
                {
                    fill: true,
                    backgroundColor: ['#2481A6', '#88F2F2', '#F2F2F2'],
                    data: [25, 65, 10],
                    borderWidth: [0, 0, 0]
                }
            ]
        };
        var myBarChartAgeTwo = new Chart(ctxAgeTwo, {type: 'pie', data: dataAgeTwo, options: optionsChartPie});
    }

    var canvasLineNew = document.getElementById("lineChartNew");
    if (canvasLineNew) {
        var ctxLine = canvasLineNew.getContext('2d');
        /*
        var dataLine = {
            labels: [],
            datasets: [
                {
                    fill: true,
                    label: 'Actual Consumption',
                    data:[24, 49, 6, 7, 21, 6],
                    backgroundColor: [
                        'rgba(225,225,225,0)'
                    ],
                    borderColor: [
                        'rgba(53,91,183,1)'
                    ],
                    borderWidth: 2.2,
                    pointStyle: 'circle',
                }
            ]
        };*/

        let lineData = [20000, 14000, 12000, 15000, 18000, 19000, 22000];
        let lineLabels =  ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

        var myBarChartNew = new Chart(ctxLine, {
            type: 'line',
            data: {
                labels: lineLabels,
                datasets: [{
                    fill: true,
                    label: 'This week',
                    data: lineData,
                    pointRadius: 10,
                    pointHoverRadius: 10,
                    borderColor: '#2481A6',
                    backgroundColor: '#E2FCFC',
                    pointBackgroundColor: '#2481A6',
                    pointBorderColor: '#FFFFFF',
                }]
            },
            options: {
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: false
                    },
                },
                layout: {
                    autoPadding: false,
                    /*
                    padding: {
                        left: 2,
                        right: 2,
                        top: 0,
                        bottom: 0,
                    }*/
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        display: false,
                    },
                    y: {
                        display: false,
                        //beginAtZero: true
                    },
                    yAxes: [
                        {
                            gridLines: {
                                display: false,
                                drawBorder: false,
                            },
                        },
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                display: false,
                                drawBorder: false,
                            },
                        },
                    ],
                },
            },
            interaction: {
                intersect: true,
            },
        });

        //var myBarChartNew = new Chart(ctxLine, {type: 'line', data: dataLine, options: {responsive: true, legend: {display: false}, title: {display: false}}});
    }

    if (document.location.pathname.indexOf("--modal-language-english-add") >= 1) {
        $('#menuLanguageAddedModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--present-notify") >= 1) {
        $('#questInfoAddOnePresentModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--present-limit") >= 1) {
        $('#questLimitPresentsModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-limit") >= 1) {
        $('#questLimitPollModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-poll-pause") >= 1) {
        $('#questPausePollModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--delete-menu") >= 1) {
        $('#menuDeletePartitionPresentModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-menus-list") >= 1) {
        $('#menusListModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--info-modal-order-all") >= 1) {
        $('#orderInfoAllModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--info-modal-order-client") >= 1) {
        $('#orderInfoClientModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--info-modal-order-detail") >= 1) {
        $('#orderInfoDetailModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--detail-order-new") >= 1) {
        $('#orderInfoDetailNewModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-choose-card-subscribe") >= 1) {
        $('#subscribeChooseCardModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-pay-by-check-subscribe") >= 1) {
        $('#subscribePayByCheckModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-cancle-subscribe") >= 1) {
        $('#subscribeCancleSubscribeModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-pay-subscribe") >= 1) {
        $('#subscribePaySubscribeModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-add-card") >= 1) {
        $('#paymentDetailsAddCardModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-update-card") >= 1) {
        $('#paymentDetailsUpdateCardModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-present-delete-error") >= 1) {
        $('#presentDeleteErrorModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-send-gift") >= 1) {
        $('#chatSendGifts').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-user-purchases") >= 1) {
        $('#chatUserPurchasesModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-user-purchase-chooses") >= 1) {
        $('#chatUserPurchasesChooseModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-user-quests") >= 1) {
        $('#userQuestsModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-user-presents") >= 1) {
        $('#userPresentsModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-user-polls") >= 1) {
        $('#userPollsModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-request-bid-total") >= 1) {
        $('#flytimeBidModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-request-bid-3333") >= 1) {
        $('#flytimeBid333Modal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-import") >= 1) {
        $('#menuImportModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-add-partition") >= 1) {
        $('#faqAddPartitionModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-edit-partition") >= 1) {
        $('#faqEditPartitionModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-poll-procent") >= 1) {
        $('#pollProcentModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-poll-V2-procent") >= 1) {
        $('#pollProcentV2Modal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-poll-choose-procent") >= 1) {
        $('#pollProcentChooseModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-choose-gift") >= 1) {
        $('#chooseGiftModal').modal("show");
    }

    if (document.location.pathname.indexOf("--modal-choose-offer") >= 1) {
        $('#chooseOfferModal').modal("show");
    }

    if (document.location.pathname.indexOf("--modal-special-guest") >= 1) {
        $('#chatAddSpecialGuestModal').modal("show");
    }

    if (document.location.pathname.indexOf("--modal-special-edit-guest") >= 1) {
        $('#chatEditSpecialGuestModal').modal("show");
    }

    if (document.location.pathname.indexOf("--modal-special-remove-question") >= 1) {
        $('#removeSpecialGuestModal').modal("show");
    }

    if (document.location.pathname.indexOf("--modal-charge-central") >= 1) {
        $('#flytimeEquipmentMoreChargeModal').modal("show");
    }

    if (document.location.pathname.indexOf("--modal-special-added") >= 1) {
        $('#specialGuestAddedModal').modal("show");
    }

    if (document.location.pathname.indexOf("--modal-special-removed") >= 1) {
        $('#specialGuestRemovedModal').modal("show");
    }

    if (document.location.pathname.indexOf("--modal-notify-disabled") >= 1) {
        $('#chatNotifyDisabledModal').modal("show");
    }

    if (document.location.pathname.indexOf("--modal-quests-preview") >= 1) {
        $('#questPreviewModal').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-quests-statistics") >= 1) {
        $('#questPreviewModalInListStatistic').modal("toggle");
    }

    if (document.location.pathname.indexOf("--modal-quests-winners-one") >= 1) {
        $('#questPreviewModalOneWinner').modal("toggle");
    }

    if (document.location.pathname.indexOf("--login-notify-error") >= 1) {
        $.notify({
            title: 'Неправильный пароль или email',
            message: ''
        }, {
            style: 'error',
            autoHide: false,
            clickToHide: true,
            globalPosition: 'top right',
        });
    }

    if (document.location.pathname.indexOf("--activity-notify-examples") >= 1) {
        $.notify({
            title: 'Стол №1 QRMenu12345',
            //titleSecond: '28.10.2024  22:00',
            //titleThird: '',
            statusText: 'Заказ сформирован',
            type: 'order',
            status: 'order_created',
        }, {
            style: 'activity',
            autoHide: false,
            clickToHide: true,
            globalPosition: 'top right',
        });
    }

    if (document.location.pathname.indexOf("--notify-examples") >= 1) {
        $.notify({
            title: 'Неправильный пароль или email',
            message: ''
        }, {
            style: 'error',
            autoHide: false,
            clickToHide: true,
            globalPosition: 'top right',
        });

        $.notify({
            title: 'Изменения сохранены',
            message: ''
        }, {
            style: 'success',
            autoHide: false,
            clickToHide: true,
            globalPosition: 'top right',
        });
    }

    $('#chooseGiftModal').on('show.bs.modal', function (e) {
        /*
        if ($('.slider-container').length > 0) {
            setTimeout(function () {
                $('.slider-container').slick({
                    infinite: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    rows: 2,
                    responsive: [
                        {
                            breakpoint: 790,
                            settings: {
                                arrows: false,
                                rows: 1,
                                slidesToShow: 0,
                                vertical: true,
                            }
                        },
                    ]
                });
            }, 500);
        }
         */
    })

    $('#openMessangerModal').on('show.bs.modal', function (e) {
        //$('.block-title--area').hide();
    });

    $('#openMessangerModal').on('hide.bs.modal', function (e) {
        //$('.block-title--area').show();
    });


    $('select.nice-select').niceSelect();

    $('.phone-mask').mask('+7 (000) 000-00-00', {placeholder: "+7 (777) 777-77-77"});
    $('.phone-last-mask').mask('0000');
    $('input[name="start-time"]').mask('00:00', {placeholder: "10:00"});
    $('input[name="stop-time"]').mask('00:00', {placeholder: "22:00"});

    $('input[name="card-cvv"]').mask('000', {placeholder: "***"});
    $('input[name="card-date"]').mask('00/00', {placeholder: "10/12"});
    $('input[name="card-num"]').mask('0000  0000  0000  0000', {placeholder: "0000  0000  0000  0000"});

    $('.number-mask').mask("0#");

    $('.email-mask').mask("A", {
        onChange: function(cep){},
        onKeyPress: function(cep, event, currentField, options){},
        translation: {
            "A": { pattern: /[\w@\-.+]/, recursive: true }
        }
    });

    $('.email-mask').on('change', function (){
       let thisVal = $(this).val();
       if (!validEmail(thisVal)) {
           $(this).val('');
       }
    });

    $('.filter-number').mask('0#');

    $('.datepicker').datepicker({
        language: 'ru-RU',
        format: 'yyyy-mm-dd'
    });

    $('.on-select-datetime').on('pick.datepicker', function (e) {
        var dataInsert = $(this).attr('data-insert');
        if (dataInsert) {
            var date = new Date(e.date);
            $(dataInsert).val(date.toISOString());
        }

        $(this).closest('.base-form--radious').find('input[type="checkbox"]').prop('checked', false);
        $(this).closest('.base-checkbox--datetime').find('input[type="checkbox"]').prop('checked', true);
    });

    $('.modal').on('shown.bs.modal', function (e) {
        $('html').addClass('freezePage');
        $('body').addClass('freezePage');
    });

    $('.modal').on('hidden.bs.modal', function (e) {
        $('html').removeClass('freezePage');
        $('body').removeClass('freezePage');
    });

    //$(".chat--chat-items-search-filter--dropdown").click(function(e){
    //    e.stopPropagation();
    //});

    /*
    $('body').on("click", ".chat--chat-items-search-filter--dropdown", function (e) {
        $(this).parent().is(".show") && e.stopPropagation();
    });


    $('.chat--chat-items-search-filter--dropdown').on('hide.bs.dropdown', function () {
        return false;
    }); */

    //$('').on({
    //    "hide.bs.dropdown":  function(e) {
    //        console.log('etst');
    //        return (typeof(e.clickEvent) != 'object');
    //    }
    //});
})();